async function requestClipboardPermission() {
  if (!navigator.permissions) {
    console.warn('Permissions API no soportada')
    return 'prompt' // intentar de todos modos
  }

  try {
    const result = await navigator.permissions.query({
      name: 'clipboard-write'
    })

    console.log('clipboard-write permission:', result.state)

    // Forzar al navegador a mostrar prompt si es posible
    if (result.state === 'granted') {
      return 'granted'
    } else if (result.state === 'prompt') {
      return 'prompt'
    } else {
      throw new Error('Clipboard permission denied')
    }
  } catch (err) {
    console.error('Error al solicitar permisos:', err)
    return 'prompt' // fallback
  }
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let successful
  try {
    successful = document.execCommand('copy')
    console.log('Fallback copy:', successful ? 'OK' : 'FAIL')
  } catch (err) {
    console.error('Fallback: unable to copy', err)
  }

  document.body.removeChild(textArea)
  return successful
}

async function copyTextToClipboard(text) {
  console.log('copying text', { text })

  // 👉 Fuerza a solicitar permiso
  const permission = await requestClipboardPermission()
  console.log('Clipboard permission result:', permission)

  // Si no existe navigator.clipboard → usar fallback
  if (!navigator.clipboard) {
    if (fallbackCopyTextToClipboard(text)) return
    throw new Error('Copy to Clipboard Error')
  }

  try {
    await navigator.clipboard.writeText(text)
    console.log('Async: Copying to clipboard was successful!')
  } catch (err) {
    console.error('Async: Could not copy text', err)
    throw err
  }
}

export default copyTextToClipboard
